/**
 * @fileoverview Zod schema for the TenantDetailModal "Update Sales Stage" form.
 * @description 'Active Client' is deliberately excluded from the selectable stage values — "Active
 * Client cannot be set through an ordinary manual stage update" (every spec's Stage Rules) — that
 * transition only happens via confirmTargetPayment. A reason note is mandatory for 'Lost'/'On
 * Hold'. Every issue message is a translation key (per this repo's i18n rule for validators),
 * translated only at the display call site in UpdateSalesStageForm.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { z } from 'zod'

export const updateStageFormSchema = z
  .object({
    stage: z.enum([
      'Prospect',
      'Contacted',
      'Meeting/Demo',
      'Proposal',
      'Negotiation',
      'Awaiting Payment',
      'On Hold',
      'Lost',
    ]),
    reason: z.string().trim().optional(),
  })
  .refine(
    (values) =>
      values.stage === 'Lost' || values.stage === 'On Hold' ? Boolean(values.reason) : true,
    {
      message: 'sales.tenantDetail.stage.errors.reasonRequired',
      path: ['reason'],
    },
  )

export type UpdateStageFormValues = z.infer<typeof updateStageFormSchema>
